import React from "react";
import Sidebar from "./Sidebar";
import Header from "./Header";
 import "../../assets/css/layout/student/StudentLayout.css";

const StudentLayout = ({children}) => {
  return (
    <div className="stu-student-layout">
      
      {/* Sidebar - Fixed position */}
      <Sidebar />

      {/* Header - Fixed position */}
      <Header />

      {/* Main Content Area */}
      <main className="stu-student-main">
        <div className="stu-student-content">
         {children}
        </div>
      </main>
    </div>
  );
};

export default StudentLayout;